export default "//cdn.scentbird.com/assets/frontbird-site/images/except-mobile_dd6629.mp4";